import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import ReactTable from 'react-table';
import { Button, Icon, Form, Message, Modal, Segment } from 'semantic-ui-react';
import feathersConnect from './../../../providers/feathersConnect';
import numeral from 'numeral';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const numberMask = createNumberMask({
  prefix: '',
  allowDecimal: true,
  requireDecimal: true,
  allowNegative: true
});

const INITIAL_STATE = {
  records: {
    loading: false,
    data: [],
    error: null
  },
  upsertModal: {
    open: false,
    loading: false,
    id: null,
    values: {
      concepto: '',
      moneda: 'PESOS',
      saldoInicial: 0
    }
  },
  removeModal: {
    open: false,
    loading: false,
    record: null,
    error: null
  }
};

const MONEDAS = [
  {
    key: 0,
    text: 'PESOS',
    value: 'PESOS'
  },
  {
    key: 1,
    text: 'DOLARES',
    value: 'DOLARES'
  }
];

class CuentasView extends Component {

  constructor (props) {
    super(props);

    this.state = INITIAL_STATE;
    this.CuentaService = this.props.feathers.service('/api/cuentas');
  }

  findRecords = () => {
    let { records } = this.state;

    this.setState({
      records: {
        ...records,
        loading: true
      }
    }, () => {
      this.CuentaService.find()
        .then(response => {
          this.setState({
            records: {
              ...records,
              data: response,
              loading: false
            }
          });
        })
        .catch(error => {
          this.setState({
            records: {
              ...records,
              error,
              loading: false
            }
          });
        });
    });
  }

  openUpsertModal = (cuenta) => {
    if (cuenta) {
      this.setState({
        upsertModal: {
          ...this.state.upsertModal,
          open: true,
          id: cuenta.id,
          values: {
            concepto: cuenta.concepto,
            moneda: cuenta.moneda,
            saldoInicial: cuenta.saldoInicial
          }
        }
      });
    } else {
      this.setState({
        upsertModal: {
          ...this.state.upsertModal,
          open: true
        }
      });
    }
  }

  dissmissUpsertModal = () => {
    this.setState({
      upsertModal: INITIAL_STATE.upsertModal
    });
  }

  upsertRecord = () => {
    let { upsertModal } = this.state;
    let values = {
      ...upsertModal.values,
      saldoInicial: numeral(upsertModal.values.saldoInicial).value()
    };

    this.setState({
      upsertModal: {
        ...upsertModal,
        loading: true
      }
    }, () => {
      if (upsertModal.id) {
        this.CuentaService.patch(upsertModal.id, values)
          .then(response => {
            this.setState({
              upsertModal: INITIAL_STATE.upsertModal
            }, () => {
              this.findRecords();
            });
          })
          .catch(error => {
            this.setState({
              upsertModal: {
                ...upsertModal,
                error
              }
            });
          });
      } else {
        this.CuentaService.create(values)
          .then(response => {
            this.setState({
              upsertModal: INITIAL_STATE.upsertModal
            }, () => {
              this.findRecords();
            });
          })
          .catch(error => {
            this.setState({
              upsertModal: {
                ...upsertModal,
                error
              }
            });
          });
      }
    });
  }

  openRemoveModal = (record) => {
    this.setState({
      removeModal: {
        ...this.state.removeModal,
        open: true,
        record
      }
    });
  }

  dismissRemoveModal = () => {
    this.setState({
      removeModal: INITIAL_STATE.removeModal
    });
  }

  removeRecord = () => {
    let { removeModal } = this.state;

    if (removeModal.loading) {
      return;
    }

    this.setState({
      removeModal: {
        ...removeModal,
        loading: true,
        error: null
      }
    }, () => {
      this.CuentaService.remove(removeModal.record.id)
        .then(response => {
          this.setState({
            removeModal: INITIAL_STATE.removeModal
          }, () => {
            this.findRecords();
          });
        })
        .catch(error => {
          this.setState({
            removeModal: {
              ...removeModal,
              error
            }
          });
        });
    });
  }

  formInputHandler = (e, input) => {
    let { upsertModal } = this.state;
    let name, value;

    if (input) {
      name = input.name;
      if (input.type === 'checkbox') {
        value = input.checked;
      } else {
        value = input.value;
      }
    } else {
      name = e.target.name;
      value = e.target.value;
    }

    this.setState({
      upsertModal: {
        ...upsertModal,
        values: {
          ...upsertModal.values,
          [name]: value
        }
      }
    });
  }

  componentDidMount () {
    this.findRecords();
  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    let { records, upsertModal, removeModal } = this.state;

    return (
      <div>
        <Segment clearing>
          <Button content="Refresh" icon="refresh" disabled={records.loading} positive onClick={this.findRecords} />
          <Button content="Nuevo" icon="add" floated="right" disabled={records.loading} primary onClick={this.openUpsertModal.bind(null)} />
        </Segment>
        {
          records.error &&
          <Message negative>
            <Message.Header>{records.error.name}</Message.Header>
            <p>{records.error.message}</p>
          </Message>
        }
        <ReactTable
          className="-striped -highlight" loading={records.loading}
          noDataText={'Sin Registros'} loadingText={'Cargando...'}
          defaultPageSize={5} pageSizeOptions={[5]}
          data={records.data}
          previousText={'<<<'} nextText={'>>>'}
          pageText={'Pagina'} ofText={'de'} rowsText={'filas'}
          columns={[
            {
              Header: '',
              width: 32,
              Cell: row => (
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    textAlign: 'center'
                  }}>
                  <Icon
                    className="edit-icon-hover" name="edit"
                    onClick={this.openUpsertModal.bind(null, row.original)} />
                </div>
              ),
              sortable: false,
              resizable: false
            },
            {
              Header: 'Concepto',
              accessor: 'concepto'
            },
            {
              Header: 'Moneda',
              accessor: 'moneda'
            },
            {
              Header: 'Saldo Inicial',
              accessor: 'saldoInicial'
            },
            {
              Header: '',
              width: 32,
              Cell: row => (
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    textAlign: 'center'
                  }}>
                  <Icon
                    color="red"
                    className="trash-icon-hover" name="trash"
                    onClick={this.openRemoveModal.bind(null, row.original)} />
                </div>
              ),
              sortable: false,
              resizable: false
            }
          ]} />
        <Modal open={upsertModal.open} onClose={this.dissmissUpsertModal}>
          <Modal.Header>{upsertModal.id ? 'Modificacion' : 'Alta'} de Cuenta</Modal.Header>
          <Modal.Content >
            <Form>
              <Form.Group>
                <Form.Input
                  name="concepto" label="Concepto"
                  value={upsertModal.values.concepto}
                  onChange={this.formInputHandler} />
                <Form.Select
                  name="moneda" label="Moneda" options={MONEDAS}
                  value={upsertModal.values.moneda}
                  onChange={this.formInputHandler} />
                <Form.Input
                  name="saldoInicial" label="Saldo Inicial"
                  children={
                    <MaskedInput
                      name="saldoInicial" mask={numberMask}
                      value={upsertModal.values.saldoInicial}
                      onChange={this.formInputHandler} />
                  } />
              </Form.Group>
            </Form>
            {
              upsertModal.error &&
              <Message negative>
                <Message.Header>{upsertModal.error.name}</Message.Header>
                <p>{upsertModal.error.message}</p>
              </Message>
            }
          </Modal.Content>
          <Modal.Actions>
            <Button negative basic content="Cancelar" icon="remove" onClick={this.dissmissUpsertModal} />
            <Button positive content="Aceptar" icon="checkmark" onClick={this.upsertRecord} />
          </Modal.Actions>
        </Modal>
        <Modal dimmer="blurring" basic size="small" open={removeModal.open} onClose={this.dismissRemoveModal}>
          <Modal.Header icon="trash">Eliminar Cuenta</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              Seguro desea eliminar la cuenta?
            </Modal.Description>
            {
              removeModal.error &&
              <Message negative>
                <Message.Header>{removeModal.error.name}</Message.Header>
                <p>{removeModal.error.message}</p>
              </Message>
            }
          </Modal.Content>
          <Modal.Actions>
            <Button basic negative inverted onClick={this.dismissRemoveModal} disabled={removeModal.loading}>
              <Icon name="remove" /> No
            </Button>
            <Button positive onClick={this.removeRecord} disabled={removeModal.loading}>
              <Icon name="checkmark" /> {removeModal.loading ? 'Eliminando' : 'Si'}
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default feathersConnect(
  connect(
    CuentasView.mapStateToProps,
    CuentasView.mapDispatchToProps
  )(CuentasView)
);



// WEBPACK FOOTER //
// ./client/components/pages/financiero/CuentasView.js